/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type labelCategoryRow_company = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"labelRow_company" | "newLabelRow_company">;
    readonly " $refType": "labelCategoryRow_company";
};
export type labelCategoryRow_company$data = labelCategoryRow_company;
export type labelCategoryRow_company$key = {
    readonly " $data"?: labelCategoryRow_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"labelCategoryRow_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "labelCategoryRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "labelRow_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newLabelRow_company"
    }
  ],
  "type": "Company"
};
(node as any).hash = '119da035b0d473b907b0149f236e0faa';
export default node;
